import { cn } from "@/lib/utils";

const lysaraLogoUrl = `${(import.meta.env.VITE_SUPABASE_URL as string).replace(/\/$/, "")}/storage/v1/object/public/brand-assets/lysara-logo.png`;

interface LysaraLogoProps {
  /** Classes applied to the wrapper element (layout/spacing). */
  className?: string;
  /** Classes applied to the logo image (sizing/filters). */
  imgClassName?: string;
  /** When true, inverts the navy wordmark for dark backgrounds. */
  invertOnDark?: boolean;
  /** Native image loading hint. */
  loading?: "eager" | "lazy";
  alt?: string;
}

export function LysaraLogo({
  className,
  imgClassName,
  invertOnDark = false,
  loading = "eager",
  alt = "Lysara",
}: LysaraLogoProps) {
  return (
    <span className={cn("inline-flex items-center", className)}>
      <img
        src={lysaraLogoUrl}
        alt={alt}
        loading={loading}
        decoding="async"
        className={cn(
          "block w-auto select-none",
          invertOnDark && "brightness-0 invert",
          imgClassName,
        )}
        draggable={false}
      />
    </span>
  );
}

export default LysaraLogo;
